import { ChangeType } from "./changetracked";

export class Contact {
    azureGuid?: string;
    emailAddress?: string;
    firstName: string;
    id: number;
    jobTitle?: string;
    lastName: string;
    midName?: string;
    phoneNumber?: string;
    displayName?: string;
    userName: string;
    adEmployeeId: string;
}

export class LotContact extends Contact {
    changeType: ChangeType;
}

